/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION - COMMENT VOLUME: STYLES --------------- ++++++++++ */
export default theme => ({
  stickyheader: {
    gap: pxToEm(8),
    '& > .content': {
      borderLeft: 'none !important',
      paddingLeft: `0 !important`
    },
    '& .previewconfig': {
      marginTop: pxToEm(-50) // move this up a bit to improve the visual awkwardness
    }
  }
});
